export const prepareRSI = (data, value) => {
    return {
        rsi: data.map((d, i) => ({
            x: new Date(d.start_date),
            y: value[i] !== undefined ? value[i] : null,
        })),

    };
};
